import React from "react";
import { stepStyles } from "./formStyles";

export const Contact = ({ formData, setForm, navigation }) => {
  const { phone, email } = formData;

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className={stepStyles.panel}>
          <h1 className={stepStyles.title}>How should we contact you?</h1>
          <div className={stepStyles.fieldStack}>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="phone"
                  value={phone}
                  onChange={setForm}
                  id="phone"
                  className={stepStyles.input}
                  placeholder="555-555-5555"
                />
              </div>
              <label htmlFor="phone" className={stepStyles.fieldLabel}>
                Phone
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="email"
                  value={email}
                  onChange={setForm}
                  id="email"
                  className={stepStyles.input}
                  placeholder="name@email.com"
                />
              </div>
              <label htmlFor="email" className={stepStyles.fieldLabel}>
                Email
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <button className={`${stepStyles.buttonAlt} w-full md:w-auto`} onClick={() => navigation.previous()}>
            Back
          </button>
          <button className={`${stepStyles.button} w-full md:w-auto`} onClick={() => navigation.next()}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
